var $e1416a5539091e36$exports = {};
$e1416a5539091e36$exports = {
    "loading": `\u{8F09}\u{5165}\u{4E2D}\u{2026}`,
    "placeholder": `\u{9078}\u{53D6}\u{2026}`
};


export {$e1416a5539091e36$exports as default};
//# sourceMappingURL=zh-TW.module.js.map
